<template>
	<div class="success-page">
		<Navbar :backButton="false" />
		<div class="order-header">
			<h1 class="order-header-title">Order #{{ orderId }}</h1>
			<h2 class="order-header-subtitle">{{ userName }}</h2>
		</div>
		<div class="panel">
			<div class="panel-header">
				<div>{{ productQuantity }} Items</div>
				<div>{{ priceTotal | currency }}</div>
			</div>
			<div
				class="pickup-item"
				v-for="(product, index) in products"
				:key="index"
			>
				<div>{{ product.quantity }}</div>
				<div>
					<div>{{ product.name }}</div>
					<div
						class="pickup-item-metadata"
						v-for="metadata in product.meta"
						:key="metadata.meta_id"
					>
						{{ metadata.label }}:
						<b>{{ metadata.value }}</b>
					</div>
				</div>
				<div>{{ product.subtotal | currency }}</div>
			</div>
		</div>
		<button
			class="button button-primary"
			@click="confirmPickup"
			:disabled="confirmed"
		>
			{{ buttonText }}
		</button>
	</div>
</template>

<style scoped>
.panel {
	background: var(--sk-grey-bg);
}

.order-header {
	background-color: var(--gR-base-90);
	height: 24%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.order-header-title,
.order-header-subtitle {
	color: var(--gR-white);
}

.order-header-title {
	font-size: 26px;
	font-weight: 800;
	margin-top: 15px;
}

.order-header-subtitle {
	font-size: 18px;
}

.panel-header {
	box-shadow: 0px 0px 2px rgba(136, 136, 136, 0.25);
	background: var(--gR-white);
	margin: -22px -18px 0px -18px;
	padding: 0 20px 20px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.panel-header > div:first-child {
	color: var(--gR-base-90);
	font-size: 16px;
	font-weight: 600;
}

.panel-header > div:last-child {
	color: var(--sk-grey3);
	font-size: 12px;
}

.pickup-item {
	box-shadow: 0px 1px 3px rgba(136, 136, 136, 0.25);
	background: var(--gR-white);
	display: flex;
	font-weight: 600;
	color: var(--gR-base-90);
	font-size: 16px;
	padding: 15px 20px;
	border-radius: 5px;
	margin-top: 10px;
}

.pickup-item div:not(.pickup-item-metadata) {
	color: var(--gR-base-90);
}

.pickup-item > div:first-child {
	width: 32px;
}

.pickup-item > div:nth-child(2) {
	flex: 1;
}

.pickup-item-metadata {
	font-size: 12px;
	color: var(--sk-grey3);
	font-weight: 400;
}

.button-primary {
	min-width: 233px;
	width: auto;
	position: fixed;
	bottom: 20px;
	left: 50%;
	transform: translateX(-50%);
}
</style>

<script>
import Navbar from "@/components/navbars/Navbar.vue"
import currencyFilterMixin from "@/mixins/currency-filter-mixin"
import loaderMixin from "@/mixins/loader-mixin"
import { OrderStatus } from "@reef-os/utils/enums/orderStatus"

export default {
	name: "OrderVerification",
	mixins: [currencyFilterMixin, loaderMixin],
	components: {
		Navbar
	},
	data: function () {
		return {
			confirmed: false
		}
	},
	computed: {
		subOrder() {
			return this.$store.state.orderStatus &&
				this.$store.state.orderStatus.sub_orders
				? this.$store.state.orderStatus.sub_orders[0]
				: {}
		},
		deliveredTime() {
			return this.subOrder.delivered_time
		},
		orderId() {
			return this.$route.params.order_id
		},
		userName() {
			return this.$store.state.orderStatus.user_name
		},
		products() {
			return this.subOrder.products ? this.subOrder.products : []
		},
		productQuantity() {
			return this.products.reduce((total, product) => {
				return total + product.quantity
			}, 0)
		},
		priceTotal() {
			return this.products.reduce((total, product) => {
				return (
					parseFloat(total) +
					parseFloat(product.subtotal) +
					parseFloat(
						product.meta.reduce((metatotal, meta) => {
							return metatotal + product.quantity * meta.price
						}, 0)
					)
				)
			}, 0)
		},
		buttonText() {
			return this.confirmed
				? "Order Confirmed!"
				: "Confirm Order Delivered"
		}
	},
	created: function () {
		this.$store.dispatch("initHome", this.$route.params.slug)
	},
	mounted: function () {
		this.$store.dispatch("getOrderStatus", {
			orderId: this.orderId
		})
		this.$store.dispatch("sendMixpanelEvent", {
			msg: "Verify Pickup Loaded"
		})
	},
	methods: {
		confirmPickup() {
			this.toggleLoader(true)
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Verify Pickup Clicked"
			})
			this.$store
				.dispatch("updateOrderStatus", {
					orderId: this.orderId,
					id: this.$store.state.orderStatus.sub_orders[0].id,
					status: OrderStatus.COMPLETED,
					markDelivered: true
				})
				.then(() => {
					this.toggleLoader(false)
					this.confirmed = true
				})
				.catch(() => {
					this.toggleLoader(false)
				})
		}
	},
	watch: {
		deliveredTime: {
			immediate: true,
			handler(newVal) {
				if (newVal) {
					this.confirmed = true
				}
			}
		}
	}
}
</script>